const SPACES = {
	ARTICLE: 'ARTICLE',
	OTHER_ARTICLES: 'OTHER_ARTICLES',
};

export default SPACES;
